import { FaTimes } from 'react-icons/fa'

const Task = ({ task, onDelete, onToggle }) => {
    return (
        <div className={`task ${task.reminder? "reminder" : ""}` } onDoubleClick={() => onToggle(task.id)}>
            <h3>
                {task.text}
                <FaTimes className="fatimes" 
                    onClick={() => onDelete(task.id, task.text)} /></h3>
            <p>{task.day}<span> at {task.time}</span></p>
            
      
        </div>
    )
}

export default Task
